<template>
  <el-dialog :visible.sync="visible" width="90%" append-to-body :close-on-click-modal="false" @closed="onClosed">
    <template slot="title">
      <div class="doc-dialog-header">
        <span class="doc-dialog-title">{{ dialogTitle }}</span>
        <div v-if="showViewToolbar" class="doc-dialog-actions">
          <el-button-group>
            <workflow-doc-buttons biz-type="productionReceipt" :biz-id="form.id" perm="production:productionReceipt" :approve-status="String(form.approveStatus || '0')" @approve="approve(true)" @unapprove="approve(false)" @done="onWorkflowDone" />
            <el-button v-if="(isAuth('production:productionReceipt:update') || isAuth('production:productionReceipt:save')) && form.approveStatus !== '2'" type="primary" size="small" @click="readonly = false">修改</el-button>
            <el-button v-if="isAuth('production:productionReceipt:delete') && form.approveStatus !== '2'" type="primary" size="small" @click="remove">删除</el-button>
          </el-button-group>
        </div>
      </div>
    </template>
    <el-form ref="dataForm" :model="form" :rules="rules" label-width="100px">
      <el-row :gutter="10">
        <el-col :span="8"><el-form-item label="入库单号"><el-input v-model="form.code" :disabled="formDisabled || !!form.id || codeReadonly" :placeholder="codeReadonly ? '保存时按单据规则生成' : '请输入入库单号'" /></el-form-item></el-col>
        <el-col :span="8"><el-form-item label="日期" prop="bizDate"><el-date-picker v-model="form.bizDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" :disabled="formDisabled" style="width:100%" /></el-form-item></el-col>
        <el-col :span="8">
          <el-form-item label="生产工单" prop="productionOrderId">
            <el-input :value="form.productionOrderCode" readonly placeholder="选择工单">
              <el-button v-if="!formDisabled" slot="append" @click="pickOrder">选择</el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="form.demands && form.demands.length" :gutter="10">
        <el-col :span="8">
          <el-form-item label="分摊策略">
            <el-select v-model="form.allocStrategy" :disabled="formDisabled" style="width:100%">
              <el-option label="按销售分配比例" value="ratio" />
              <el-option label="按需求行序优先" value="priority" />
              <el-option label="手工分摊" value="manual" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-table :data="form.lines" border :header-cell-style="headStyle">
        <el-table-column prop="materialCode" label="产品编码" min-width="120" header-align="center" align="left" />
        <el-table-column prop="materialName" label="产品名称" min-width="140" header-align="center" align="left" />
        <el-table-column prop="remainQuantity" label="可入库" width="100" header-align="center" align="left" />
        <el-table-column label="入库数量" width="140" header-align="center" align="left">
          <template slot-scope="s">
            <el-input-number v-model="s.row.quantity" :disabled="formDisabled" :min="0" :max="receiptQuantityMax(s.row)" :precision="2" size="small" style="width:100%" />
          </template>
        </el-table-column>
        <el-table-column label="入库库位" min-width="220" header-align="center" align="left">
          <template slot-scope="s"><warehouse-location-select v-model="s.row.wareHouseId" :disabled="formDisabled" size="small" /></template>
        </el-table-column>
      </el-table>
      <div v-if="form.demands && form.demands.length && form.allocStrategy !== 'manual'" class="demand-section">
        <div class="section-title">销售需求</div>
        <el-table :data="form.demands" border :header-cell-style="headStyle">
          <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
          <el-table-column prop="salesOrderCode" label="销售单号" min-width="120" header-align="center" align="left" />
          <el-table-column label="分配量" width="100" header-align="center" align="left"><template slot-scope="s">{{ formatQty(s.row.allocatedQty) }}</template></el-table-column>
          <el-table-column label="已入库" width="100" header-align="center" align="left"><template slot-scope="s">{{ formatQty(s.row.receivedQty) }}</template></el-table-column>
          <el-table-column label="待入库" width="100" header-align="center" align="left"><template slot-scope="s">{{ formatQty(remainDemand(s.row)) }}</template></el-table-column>
        </el-table>
      </div>
      <div v-if="form.allocStrategy === 'manual' && form.demands && form.demands.length" class="demand-section">
        <div class="section-title">手工分摊（合计须等于入库数量）</div>
        <el-table :data="manualAllocs" border :header-cell-style="headStyle">
          <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
          <el-table-column prop="salesOrderCode" label="销售单号" min-width="120" header-align="center" align="left" />
          <el-table-column label="分配量" width="100" header-align="center" align="left"><template slot-scope="s">{{ formatQty(s.row.allocatedQty) }}</template></el-table-column>
          <el-table-column label="已入库" width="100" header-align="center" align="left"><template slot-scope="s">{{ formatQty(s.row.receivedQty) }}</template></el-table-column>
          <el-table-column label="本次分摊" width="140" header-align="center" align="left">
            <template slot-scope="s"><el-input-number v-model="s.row.allocQty" :disabled="formDisabled" :min="0" :precision="2" size="small" style="width:100%" /></template>
          </el-table-column>
        </el-table>
      </div>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-if="!formDisabled" type="primary" @click="save">保存</el-button>
    </span>
    <el-dialog title="选择工单" :visible.sync="orderDlg" width="700px" append-to-body>
      <el-table :data="orders" border :header-cell-style="headStyle" @row-click="onPickOrder">
        <el-table-column prop="productionOrderCode" label="工单号" min-width="140" />
        <el-table-column prop="materialCode" label="成品" min-width="120" />
        <el-table-column prop="orderStatus" label="状态" width="90">
          <template slot-scope="s">{{ s.row.orderStatus === '1' ? '已下达' : s.row.orderStatus === '3' ? '已完工' : (s.row.orderStatus || '') }}</template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </el-dialog>
</template>

<script>
import WorkflowDocButtons from '../../components/WorkflowDocButtons.vue'
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import WarehouseLocationSelect from '../../components/WarehouseLocationSelect.vue'

function today() {
  const d = new Date()
  const p = n => String(n).padStart(2, '0')
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()) + ' 00:00:00'
}

export default {
  name: 'ProductionReceiptAddOrUpdate',
  components: { WorkflowDocButtons, WarehouseLocationSelect },
  data() {
    return {
      visible: false,
      readonly: false,
      codeReadonly: false,
      orderDlg: false,
      orders: [],
      ordersRequestId: 0,
      permCodes: [],
      form: { lines: [], demands: [], allocStrategy: 'ratio', productionOrderCode: '' },
      manualAllocs: [],
      headStyle: { background: '#f5f7fa', color: '#606266', textAlign: 'center' },
      rules: {
        bizDate: [{ required: true, message: '日期不能为空', trigger: 'change' }],
        productionOrderId: [{ required: true, message: '请选择工单', trigger: 'change' }]
      }
    }
  },
  computed: {
    formDisabled() { return this.readonly || String(this.form.approveStatus) === '2' },
    showViewToolbar() { return this.readonly && !!this.form.id },
    dialogTitle() {
      if (this.readonly) return '入库详情'
      return this.form.id ? '修改入库' : '新增入库'
    }
  },
  created() {
    this.loadPerms()
    this.loadOrders()
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    resolveCode() {
      request.post('/base/docNumberRule/resolve', { docType: 'productionReceipt' }).then(res => {
        if (!this.visible || this.form.id) return
        const rule = res.data || {}
        this.codeReadonly = !!rule.codeReadonly
        if (rule.previewCode) this.form.code = rule.previewCode
      }).catch(() => {})
    },
    loadOrders(includeId) {
      const include = includeId || (this.form && this.form.productionOrderId) || ''
      const requestId = ++this.ordersRequestId
      return request.get('/production/order/ordersForBiz', { params: { includeProductionOrderId: include } })
        .then(res => { if (requestId === this.ordersRequestId) this.orders = res.data || [] })
        .catch(() => { if (requestId === this.ordersRequestId) this.orders = [] })
    },
    pickOrder() {
      this.orderDlg = true
      this.loadOrders(this.form.productionOrderId)
    },
    onPickOrder(row) {
      if (!row) return
      this.form.productionOrderId = row.productionOrderId
      this.form.productionOrderCode = row.productionOrderCode || ''
      this.orderDlg = false
      this.fillProduct()
    },
    onWorkflowDone() {
      this.$emit('refreshDataList')
      if (this.form && this.form.id) this.init(this.form.id, true)
    },
    onClosed() {
      this.readonly = false
      this.orderDlg = false
      this.manualAllocs = []
      this.form = { lines: [], demands: [], allocStrategy: 'ratio', productionOrderCode: '' }
    },
    init(idOrRow, readonly) {
      this.visible = true
      this.readonly = !!readonly
      this.codeReadonly = false
      if (this.readonly && idOrRow) {
        const openView = prefill => {
          const order = this.orders.find(item => item.productionOrderCode === prefill.productionOrderCode)
          const bizDate = prefill.bizDate && String(prefill.bizDate).length <= 10 ? prefill.bizDate + ' 00:00:00' : (prefill.bizDate || '')
          this.form = { id: prefill.id, code: prefill.code || '', bizDate, productionOrderId: prefill.productionOrderId || (order ? order.productionOrderId : ''), productionOrderCode: prefill.productionOrderCode || (order ? order.productionOrderCode : ''), approveStatus: String(prefill.approveStatus || '0'), remark: prefill.remark || '', allocStrategy: 'ratio', demands: [], lines: [] }
          const ordersReady = this.loadOrders(this.form.productionOrderId)
          request.get('/production/receipt/lines', { params: { id: prefill.id } }).then(async res => {
            this.form.lines = res.data && res.data.length
              ? res.data.map(row => ({ ...row, quantity: Number(row.quantity || 0), savedQuantity: Number(row.quantity || 0), remainQuantity: null }))
              : [{ materialId: '', materialCode: '', materialName: '', quantity: 0, savedQuantity: 0, wareHouseId: '', remainQuantity: null }]
            await ordersReady
            this.fillProduct()
          }).catch(() => {})
        }
        const id = typeof idOrRow === 'object' ? idOrRow.id : idOrRow
        if (id) {
          request.get('/production/receipt/info', { params: { id } }).then(res => {
            openView(res.data || (typeof idOrRow === 'object' ? idOrRow : { id }))
          }).catch(() => { openView(typeof idOrRow === 'object' ? idOrRow : { id }) })
        }
        return
      }
      const prefill = idOrRow && typeof idOrRow === 'object' ? idOrRow : null
      this.manualAllocs = []
      this.form = { code: '', bizDate: today(), productionOrderId: (prefill && prefill.productionOrderId) || '', productionOrderCode: (prefill && prefill.productionOrderCode) || '', remark: '', allocStrategy: 'ratio', demands: [], lines: [{ materialId: '', materialCode: '', materialName: '', quantity: 1, wareHouseId: '' }] }
      this.resolveCode()
      if (this.form.productionOrderId) {
        const orderId = this.form.productionOrderId
        this.loadOrders(orderId).then(() => {
          if (this.visible && this.form.productionOrderId === orderId) this.fillProduct()
        })
      }
    },
    fillProduct() {
      const order = this.orders.find(item => item.productionOrderId === this.form.productionOrderId)
      const line = this.form.lines[0]
      if (!this.form.productionOrderId || !line) return
      if (order) {
        this.form.productionOrderCode = order.productionOrderCode || this.form.productionOrderCode || ''
        line.materialCode = order.materialCode || ''
        line.materialName = order.materialName || ''
        line.materialId = order.materialId || line.materialId || ''
      }
      request.get('/production/receipt/remain', { params: { productionOrderId: this.form.productionOrderId, excludeReceiptId: this.form.id || '' } }).then(res => {
        const remain = Number((res.data && res.data.remainQuantity) || 0)
        this.$set(line, 'remainQuantity', remain)
        if (!this.formDisabled && !this.form.id) line.quantity = remain > 0 ? remain : 0
      }).catch(() => {})
      this.loadDemands()
    },
    loadDemands() {
      if (!this.form.productionOrderId) { this.form.demands = []; this.manualAllocs = []; return }
      request.get('/production/receipt/demands', { params: { productionOrderId: this.form.productionOrderId, receiptId: this.form.id || '' } }).then(res => {
        const data = res.data || {}
        this.form.allocStrategy = data.allocStrategy || 'ratio'
        this.form.demands = data.demands || []
        const saved = data.demandAllocs || []
        this.manualAllocs = this.form.demands.map(row => {
          const hit = saved.find(item => item.demandId === row.demandId)
          return { demandId: row.demandId, salesOrderLineId: row.salesOrderLineId, salesOrderCode: row.salesOrderCode, allocatedQty: row.allocatedQty, receivedQty: row.receivedQty, allocQty: hit ? Number(hit.allocQty || 0) : 0 }
        })
      }).catch(() => {})
    },
    formatQty(val) {
      const n = Number(val || 0)
      return Number.isNaN(n) ? '0' : n.toLocaleString('zh-CN', { maximumFractionDigits: 2 })
    },
    receiptQuantityMax(row) {
      return Math.max(Number(row.remainQuantity || 0), Number(row.savedQuantity || 0))
    },
    remainDemand(row) {
      return Math.max(0, Number(row.allocatedQty || 0) - Number(row.receivedQty || 0))
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        const line = this.form.lines[0] || {}
        if (!line.materialId) { this.$message.warning('请选择工单产品'); return }
        if (!line.wareHouseId) { this.$message.warning('请维护入库仓库'); return }
        const demandAllocs = this.form.allocStrategy === 'manual'
          ? this.manualAllocs.filter(row => Number(row.allocQty) > 0).map(row => ({ demandId: row.demandId, salesOrderLineId: row.salesOrderLineId, allocQty: row.allocQty }))
          : []
        if (this.form.allocStrategy === 'manual' && this.form.demands && this.form.demands.length) {
          const sum = demandAllocs.reduce((total, row) => total + Number(row.allocQty || 0), 0)
          if (Math.abs(sum - Number(line.quantity || 0)) > 0.000001) { this.$message.warning('手工分摊合计须等于入库数量'); return }
        }
        request.post('/production/receipt/save', {
          id: this.form.id, code: this.form.code, bizDate: this.form.bizDate, productionOrderId: this.form.productionOrderId, remark: this.form.remark,
          allocStrategy: this.form.allocStrategy || 'ratio', demandAllocs,
          lines: [{ materialId: line.materialId, quantity: line.quantity, wareHouseId: line.wareHouseId, remark: '' }]
        }).then(() => { this.$message.success('保存成功'); this.visible = false; this.$emit('refreshDataList') }).catch(() => {})
      })
    },
    approve(yes) {
      request.post(yes ? '/production/receipt/approve' : '/production/receipt/unapprove', { id: this.form.id }).then(() => { this.$message.success('操作成功'); this.visible = false; this.$emit('refreshDataList') }).catch(() => {})
    },
    remove() {
      this.$confirm('确定删除这张未审核完工入库单?', '提示', { type: 'warning' }).then(() => {
        request.post('/production/receipt/delete', { id: this.form.id }).then(() => { this.$message.success('已删除'); this.visible = false; this.$emit('refreshDataList') }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.doc-dialog-header { display: flex; align-items: center; justify-content: space-between; padding-right: 28px; }
.doc-dialog-title { font-size: 16px; font-weight: 600; }
.doc-dialog-actions .el-button { margin-left: 0; }
.demand-section { margin-top: 12px; }
.section-title { margin-bottom: 8px; font-weight: 600; }
</style>
